export default __webpack_public_path__ + "static/media/verticalDotMenu.10f12b6d.svg";